import React, { useEffect } from "react";
import { Outlet, useLocation, Link } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";

export const Layout = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-[#F7F3EC]">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export const CTABand = () => (
  <section className="bg-[#7A8B6F]" data-testid="cta-band">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 lg:py-20 flex flex-col lg:flex-row items-center justify-between gap-8">
      <div>
        <p className="section-label text-white/80">Ready when you are</p>
        <h2 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-white mt-3 max-w-xl">
          Let's build something that lasts.
        </h2>
      </div>
      <Link
        to="/contact"
        data-testid="cta-band-button"
        className="bg-[#F7F3EC] text-[#2B2B2B] hover:bg-white transition-colors px-10 py-4 text-sm font-bold tracking-wider uppercase whitespace-nowrap"
      >
        Get a Free Quote
      </Link>
    </div>
  </section>
);
